module.exports = __webpack_public_path__ + "img/stock0.cbee2b29.png";